import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import {
	IGroupedPeriodStatisticsChartData,
	IPeriodStatisticsChartData,
} from "@data-types/sport-stats/SportStatsTypes";
import { highlightTeam } from "@utils/offer";
import classnames from "classnames";
import SportStatisticsStore from "@state/stores/offer/statistics/SportStatisticsStore";
import { EventStatsGraph } from "@features/offer/shared/statistics";

export default observer(function GroupedEventStatsChart(props: {
	store: SportStatisticsStore;
}) {
	if (!props.store.filteredMatchStats.groupedMatchStatisticsChartData) {
		return null;
	}

	return (
		<>
			{props.store.filteredMatchStats.groupedMatchStatisticsChartData.map(
				(group, index) =>
					group.data &&
					group.data.length > 0 && (
						<EventStatsGroup
							key={index}
							index={index}
							statsGroup={group}
						/>
					)
			)}
		</>
	);
});

function EventStatsGroup(props: {
	statsGroup: IGroupedPeriodStatisticsChartData;
	index?: number;
}) {

	return (
		<div key={props.index} className="card card--raised card--stats">
			<StatsGroupHeader
				title={props.statsGroup.title}
			/>

			<StatsGroupBody
				statsData={props.statsGroup.data}
			/>
		</div>
	);
}

function StatsGroupHeader(props: {
	title: string;
}) {
	const { t } = useTranslation();

	return (
		<div
			className={classnames(
				"card__header card--stats__header"
			)}
		>
			<div className="card__title card__title--base card--stats__heading">
				{t(props.title)}
			</div>
		</div>
	);
}

function StatsGroupBody(props: {
	statsData: IPeriodStatisticsChartData[];
}) {

	const { t } = useTranslation();

	const setGraphName = (title: string, key: string | null) => {
		const matchStatName = t(title, { defaultValue: "" });

		if (key != null) {
			return `${matchStatName} (${key})`;
		}

		return matchStatName;
	};

	return (
		<div
			className={classnames("card--stats__body")}
		>
			{props.statsData.map((stat, index) => (
				<EventStatsGraph
					key={index}
					graphName={setGraphName(stat.title, stat.key)}
					info={t(stat.infoSection, { defaultValue: "" })}
					data={stat.data}
					max={stat.max}
					removeValues
					highlightTeam={highlightTeam(stat.data)}
				/>
			))}
		</div>
	);
}
